import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonGroup, createStyles, makeStyles } from '@material-ui/core';
import { AppPermissionLevel } from 'common/constants/permissions';
import { CustomTheme } from 'common/ui/interfaces';
import messages from 'common/messages/messages';

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    group: {
      padding: 2,
      backgroundColor: theme.palette.secondary.light,
      borderRadius: 3,
    },
    btn: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  }),
);

interface IPolicyLevelSwitcher {
  onChange: (level: AppPermissionLevel) => void;
  value: AppPermissionLevel;
  isDisabled?: boolean;
}

const PolicyLevelSwitcher: FC<IPolicyLevelSwitcher> = ({ onChange, value, isDisabled }) => {
  const classes = useStyles();
  return (
    <ButtonGroup disabled={isDisabled} disableElevation fullWidth className={classes.group}>
      <Button
        onClick={() => onChange(AppPermissionLevel.Club)}
        fullWidth
        className={classes.btn}
        color={value === AppPermissionLevel.Club ? 'primary' : undefined}
        variant={value === AppPermissionLevel.Club ? 'contained' : 'text'}
      >
        <FormattedMessage {...messages.clubTitle} />
      </Button>

      <Button
        onClick={() => onChange(AppPermissionLevel.Corporate)}
        fullWidth
        className={classes.btn}
        color={value === AppPermissionLevel.Corporate ? 'primary' : undefined}
        variant={value === AppPermissionLevel.Corporate ? 'contained' : 'text'}
      >
        <FormattedMessage {...messages.corporateTitle} />
      </Button>

      <Button
        onClick={() => onChange(AppPermissionLevel.ClubCorporate)}
        fullWidth
        className={classes.btn}
        color={value === AppPermissionLevel.ClubCorporate ? 'primary' : undefined}
        variant={value === AppPermissionLevel.ClubCorporate ? 'contained' : 'text'}
      >
        <FormattedMessage {...messages.clubAndCorporateTitleShort} />
      </Button>
    </ButtonGroup>
  );
};

export default PolicyLevelSwitcher;
